<template>
  <div class="sc-card mb-3" style="min-height: 192px;">
    <div class="sc-card-header d-flex justify-content-between">
      <div>
        <span
          class="text-size-4 text-weight-medium"
          :style="useStyles.colorDark"
        >
          Seu saldo
        </span>
        <h3
          class="text-size-7 text-weight-semi-bold font-public-sans"
          :style="useStyles.colorDark"
        >
          {{ available || 0 }}
        </h3>
      </div>

      <!-- <Button
        class="align-self-start"
        variant="card"
        style="color: #495057 !important;"
        @click.native="handleBankTransfer"
      >
        Retirar saldo
      </Button> -->
    </div>

    <!-- <div class="sc-card-divider m-0" />

    <div class="sc-card-footer d-flex align-items-center">
      <div class="flex-fill">
        <small
          class="text-size-3 text-weight-medium"
          :style="useStyles.colorGray"
        >
          A receber
        </small>
        <h6
          class="text-size-4 text-weight-semi-bold font-public-sans"
          :style="useStyles.colorDark"
        >
          {{ toReceive }}
        </h6>
      </div>

      <div class="flex-fill">
        <small
          class="text-size-3 text-weight-medium"
          :style="useStyles.colorGray"
        >
          Bloqueado
        </small>
        <h6
          class="text-size-4 text-weight-semi-bold font-public-sans"
          :style="useStyles.colorDark"
        >
          {{ blocked }}
        </h6>
      </div>
    </div> -->
  </div>
</template>

<script>
// import Button from "./Button";
import { centsToBRL } from "./../utils/currency/convert";
import Swal from "sweetalert2";

export default {
  name: "TransferBalanceCard",
  components: {
    // Button
  },
  async mounted() {
    await this.$store.dispatch("doctor/getBalances");
  },
  methods: {
    handleBankTransfer() {
      if (!this.$store.state.doctor.bank_account.id) {
        return Swal.fire({
          title: "Atenção!",
          text:
            "É necessário ter uma conta cadastrada para poder efetuar retirada de saldo.",
          icon: "warning",

          confirmButtonColor: "#49838a"
        });
      }
      return this.$bvModal.show("bankTransfer");
    }
  },
  computed: {
    balances() {
      return this.$store.state.doctor.balances;
    },
    available() {
      return this.balances.current[0].amount;
    },
    toReceive() {
      return this.balances.future[0].amount;
    },
    blocked() {
      return this.balances.unavailable[0].amount;
    },
    useStyles() {
      return {
        colorDark: {
          color: "#343a40"
        },
        colorGray: {
          color: "#adb5bd"
        }
      };
    }
  }
};
</script>
